import {BannerType, BannerTypes} from 'shared/components/MessageBanner/Themes';
import StyledIcon from 'shared/Icons/components/StyledIcon';
import {intlFormatSingleMessage} from 'shared/IntlFormatMessage/utils/intlMesssageFormat';
import {IconSize} from 'styles/Base';

interface Props {
  type: BannerType;
}

const Icon = ({type}: Props) => (
  <StyledIcon
    props={{
      url: BannerTypes[type].icon,
      'aria-label': intlFormatSingleMessage(type === 'info' ? 'Information' : type),
      size: IconSize.PX_24,
      color: BannerTypes[type].styles.text
    }}
  />
);

export default Icon;
